const DEFAULT_APP_TITLE = "MozzoApp";

const normalizeTitleSegment = (value) =>
  String(value || "")
    .trim()
    .replace(/\s+/g, " ");

export const buildPageTitle = (...segments) => {
  const normalizedSegments = segments
    .map((segment) => normalizeTitleSegment(segment))
    .filter(Boolean);

  return normalizedSegments.length > 0
    ? normalizedSegments.join(" | ")
    : DEFAULT_APP_TITLE;
};

export const setDocumentTitle = (...segments) => {
  if (typeof document === "undefined") {
    return;
  }

  document.title = buildPageTitle(...segments);
};

export const getDefaultAppTitle = () => DEFAULT_APP_TITLE;
